import { useTranslation } from 'react-i18next';
import BreadcrumbLayout from 'components/layout/BreadcrumbLayout';
import BulkSetPermissionsForm from './BulkSetPermissionsForm';

const BulkSetPermissions = () => {
  const { t } = useTranslation();
  return (
    <BreadcrumbLayout
      titleKey="ui.event-management.bulk-set-user-permissions.header"
      activeTextKey="ui.event-management.bulk-set-user-permissions.header"
      crumbs={{
        '/': t('ui.event-management.events.nav.home'),
        '/organisations': t('ui.event-management.organisations.title'),
      }}
      headingKey="ui.event-management.bulk-set-user-permissions.header"
    >
      <BulkSetPermissionsForm />
    </BreadcrumbLayout>
  );
};

export default BulkSetPermissions;
